import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalPath, ogType = 'website', schema }: SEOHeadProps) {
  const location = useLocation();
  const fullTitle = title.includes('91动漫') ? title : `${title} - 91动漫`;
  const canonical = canonicalPath ? `https://beyondtoon.github.io${canonicalPath}` : `https://beyondtoon.github.io${location.pathname}`;
  const finalKeywords = keywords || '91动漫,动漫在线观看,免费追番,国漫,日漫';

  const baseMeta = {
    title: fullTitle,
    description,
    keywords: finalKeywords,
    canonical,
  };

  const ogData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: fullTitle,
    description,
    url: canonical,
  };

  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            document.title = ${JSON.stringify(baseMeta.title)};
            const desc = document.querySelector('meta[name="description"]');
            if (desc) desc.setAttribute('content', ${JSON.stringify(baseMeta.description)});
            const kw = document.querySelector('meta[name="keywords"]');
            if (kw) kw.setAttribute('content', ${JSON.stringify(baseMeta.keywords)});
            const can = document.querySelector('link[rel="canonical"]');
            if (can) can.setAttribute('href', ${JSON.stringify(baseMeta.canonical)});
            const ogt = document.querySelector('meta[property="og:title"]');
            if (ogt) ogt.setAttribute('content', ${JSON.stringify(fullTitle)});
            const ogd = document.querySelector('meta[property="og:description"]');
            if (ogd) ogd.setAttribute('content', ${JSON.stringify(description)});
            const ogu = document.querySelector('meta[property="og:url"]');
            if (ogu) ogu.setAttribute('content', ${JSON.stringify(canonical)});
            const ogtype = document.querySelector('meta[property="og:type"]');
            if (ogtype) ogtype.setAttribute('content', ${JSON.stringify(ogType)});
            const twt = document.querySelector('meta[name="twitter:title"]');
            if (twt) twt.setAttribute('content', ${JSON.stringify(fullTitle)});
            const twd = document.querySelector('meta[name="twitter:description"]');
            if (twd) twd.setAttribute('content', ${JSON.stringify(description)});
          `,
        }}
      />
      <script type="application/ld+json">
        {JSON.stringify(ogData)}
      </script>
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </>
  );
}